define('AdvancedSearch.SS2Model',
  [
    'SCModel',
    'Utils'
  ],
  function (
    SCModelComponent,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function AdvancedSearch() {
      SCModel.call(this);

      this.urlRoot = function () {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath('Modules/AdvancedSearch/SuiteScript2/AdvancedSearch.Service.ss'), true
        );
      };
    }
    AdvancedSearch.prototype = Object.create(SCModel.prototype);

    AdvancedSearch.prototype.constructor = AdvancedSearch;

    return 	AdvancedSearch;

  });
